import Cookies from 'js-cookie'
import {getSite,getSystem} from './site'


export function getSupportList(){
	var sys=getSystem()
	if(sys=='ept'){
		return ['zh_CN']
	}
	if(sys=='th'){
		return ['th_TH', 'zh_CN', 'en_US']
	}
	if(sys=='EJSHOP'){
		return ['zh_CN']
	}
}

export function getLanguage(){
	var language=Cookies.get('language')
	if(language)return language
	var sys=getSystem()
	if(sys=='ept'){
		return "zh_CN"
	}
	if(sys=='th'){
		return "th_TH"
	}
	if(sys=='EJSHOP'){
		return "zh_CN"
	}
	if(sys=='id'){
		return "zh_CN"
	}
}

export function getTemplateLanguage(){
	var sys=getSystem()
	if(sys=='ept'){
		var site=getSite()
		var map={
			'US':'en_US',
			'RU':'ru_RU',
			'ES':'es_ES'
		}
		if(!map[site])console.error("无法获取模板语言")
		return map[site]
	}else{
		return getLanguage()
	}
}

export function getEditAbleLanguage(){
	var sys=getSystem()
	if(sys=='ept'){
		var site=getSite()
		var map={
			'US':'en_US',
			'RU':'ru_RU',
			'ES':'es_ES'
		}
		return [map[site]]
	}
	if(sys=='th'){
		return [
			'th_TH',
			'zh_CN',
			'en_US'
		]
	}
	if(sys=='EJSHOP'){
		return [
			'zh_CN'
		]
	}
}